import { useSetting } from '@tencent/setting-vue-webpack-plugin';
var setting = useSetting('环境兼容', {
  pad链接: '',
  pc链接: '',
  pad图: ''
});
window.envSetting = setting;